import 'focus-visible'
import 'instant.page'
import './components/analytics'
import './components/lazyload'
import './plugins/external-links'
import './plugins/scaleable-embeds'
import './components/home'
import './components/table'
